"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _TopicConfigurationDeprecated_1 = require("./_TopicConfigurationDeprecated");
var _QueueConfigurationDeprecated_1 = require("./_QueueConfigurationDeprecated");
var _CloudFunctionConfiguration_1 = require("./_CloudFunctionConfiguration");
exports._NotificationConfigurationDeprecated = {
    type: "structure",
    required: [],
    members: {
        TopicConfiguration: {
            shape: _TopicConfigurationDeprecated_1._TopicConfigurationDeprecated
        },
        QueueConfiguration: {
            shape: _QueueConfigurationDeprecated_1._QueueConfigurationDeprecated
        },
        CloudFunctionConfiguration: {
            shape: _CloudFunctionConfiguration_1._CloudFunctionConfiguration
        }
    }
};
//# sourceMappingURL=_NotificationConfigurationDeprecated.js.map